import $axios from './requestAxios'
import { isAddressId } from './addressId'
import Toast from 'vant';

// 地址列表接口
  export let getAddressinfo = (obj)=>{
    $axios({
      method: "POST",
      url: "/shop/address/list",
      data: {},
      success: data => {
        if (data.data.status == 'success') {
          obj.callBack(data.data.data)
          //  console.log(obj.item)
        } else {
          Toast(data.data.message)
          return;
        }
      }
    });
  }

//不强制添加默认地址  有默认地址就设置默认地址  没有的话选择地址列表的第一个地址  默认选中的addressid删除后 把第一项设置为默认,保证address每次都有值
  // export let getIsDefault = (obj)=>{
  //   console.log(obj.addressinfo)
  //   // 接参
  //   let addressId = isAddressId.fetch()
  //   if(addressId==''){
  //     isAddressId.save(obj.addressinfo[0].id)
  //   }
  //   let addresslist = obj.addressinfo.filter(value => {
  //     return value.is_default == 1;
  //   })[0];
  //   if(typeof(addresslist)=='undefined'){
  //     addresslist = obj.addressinfo[0]
  //   }
  //   //传参
  //   obj.callBack(addresslist)
  // }


// WEBPACK FOOTER //
// ./src/utils/fun.js